import {
    REQUEST_PAYMENTREQUEST_ONGOING,
    RECEIVE_PAYMENTREQUEST_ONGOING,
    FAILURE_PAYMENTREQUEST_ONGOING
} from './constants';
import { CALL_API } from '../../../../middlewares/api';
import _ from 'lodash';

// payment ongoing
export function fetchPaymentRequestOnGoingIfNeeded() {
    return {
        [CALL_API]: {
            endpoint: '/payment/ongoing',
            types: [
                REQUEST_PAYMENTREQUEST_ONGOING,
                RECEIVE_PAYMENTREQUEST_ONGOING,
                FAILURE_PAYMENTREQUEST_ONGOING
            ],
            shouldCallAPI: state => shouldFetchPaymentRequestOnGoing(state),
            authenticated: true
        }
    };
}

const shouldFetchPaymentRequestOnGoing = state => {
    const data = state.account.paymentongoing;
    const fetching = state.account.fetching;

    if (fetching) {
        return false;
    } else if (_.isEmpty(data)) {
        return true;
    } else {
        return false;
    }
};



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/ongoing/actions.js